module.exports = __webpack_public_path__ + "static/media/share.f3f4066f.svg";